"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSellerShippingPrice = void 0;
var util_1 = require("@aperza/util");
var react_1 = require("react");
var react_i18next_1 = require("react-i18next");
var useSellerShippingPrice = function () {
    var t = react_i18next_1.useTranslation().t;
    var unlimited = t('seller.shippingFee.unlimited');
    var _a = __read(react_1.useState([]), 2), locations = _a[0], setLocations = _a[1];
    var _b = __read(react_1.useState(), 2), tableConfig = _b[0], setTableConfig = _b[1];
    var updateLocations = function (_locations) {
        setLocations(_locations);
    };
    react_1.useEffect(function () {
        /// TODO : Sort Base Shipping Fees
        var sortedBaseShippingFeesColumns = new Set();
        var sortedAdditionalShippingFeesWeightColumns = new Set();
        var sortedAdditionalShippingFeesQuantityColumns = new Set();
        var data = locations.map(function (location) {
            var baseShippingFees = {};
            /// TODO : BASE SHIPPING FEES
            location.baseShippingFees.forEach(function (fee) {
                var columnName = util_1.CurrencyUtil.parseCurrency(fee.priceFrom) +
                    '~' +
                    (fee.priceTo ? util_1.CurrencyUtil.parseCurrency(fee.priceTo) : unlimited);
                sortedBaseShippingFeesColumns.add(columnName);
                baseShippingFees[columnName] =
                    fee.shippingFee > 0 ? util_1.CurrencyUtil.parseCurrency(fee.shippingFee, true) : fee.shippingFee;
            });
            /// TODO : additional Shipping Fee for the weight
            var additionalShippingFeesWeight = location.additionalShippingFeesWeight.map(function (fee) {
                sortedAdditionalShippingFeesWeightColumns.add('id_w_' + fee.shippingPlanDisplayId);
                return {
                    shippingPlanDisplayId: fee.shippingPlanDisplayId,
                    referenceWeight: fee.referenceWeight,
                    shippingFeePerAdditionalKilo: fee.shippingFeePerAdditionalKilo,
                    shippingFee: fee.shippingFee,
                };
            });
            /// TODO : additional Shipping Fee for the quantity
            var additionalShippingFeesQuantity = location.additionalShippingFeesQuantity.map(function (fee) {
                sortedAdditionalShippingFeesQuantityColumns.add('id_q_' + fee.shippingPlanDisplayId);
                return {
                    shippingPlanDisplayId: fee.shippingPlanDisplayId,
                    shippingFeePerAdditionalQuantity: fee.shippingFeePerAdditionalQuantity,
                    shippingFee: fee.shippingFee,
                };
            });
            return {
                locationCode: location.locationCode,
                locationName: location.locationName,
                baseShippingFees: baseShippingFees,
                additionalShippingFeesWeight: additionalShippingFeesWeight,
                additionalShippingFeesQuantity: additionalShippingFeesQuantity,
            };
        });
        setTableConfig({
            data: data,
            sortedBaseShippingFeesColumns: sortedBaseShippingFeesColumns,
            sortedAdditionalShippingFeesWeightColumns: sortedAdditionalShippingFeesWeightColumns,
            sortedAdditionalShippingFeesQuantityColumns: sortedAdditionalShippingFeesQuantityColumns,
        });
    }, [locations]);
    return {
        updateLocations: updateLocations,
        tableConfig: tableConfig,
    };
};
exports.useSellerShippingPrice = useSellerShippingPrice;
